import { render, staticRenderFns } from "./PresupuestoRenovacionBonos.vue?vue&type=template&id=0ce46be6"
import script from "./PresupuestoRenovacionBonos.vue?vue&type=script&lang=js"
export * from "./PresupuestoRenovacionBonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports